import { WEBSHARE_PROXY_DNS_ADDRESS } from "@/config/constants";
import { bash } from "@/components/CodeExample/templates";
import { Order } from "@/types/component/TableTypes";
import { FilterType } from "../tables/PaginatedDataGrid";

export function getCountryCodeFilter(countryFilter: string[] | null) {
  if (countryFilter === null) {
    return undefined;
  }
  if (countryFilter.length === 0) {
    return undefined;
  }
  return countryFilter.join();
}

export function getSearchValue(searchValue: string, connectionMethod: string) {
  if (connectionMethod == "backbone") {
    return undefined;
  }
  if (searchValue == "") {
    return undefined;
  } else {
    return searchValue;
  }
}

const FilterNameSuffixMap: { [key: string]: string } = {
  isAnyOf: "__in",
  equals: "",
  contains: "__contains",
};
export function getFilters(filters: FilterType[] | undefined) {
  if (!filters) {
    return {};
  }

  return filters.reduce((acc: { [key: string]: string }, filter) => {
    const filterName = `${filter.field}${FilterNameSuffixMap[filter.operator]}`;

    if (Array.isArray(filter.value)) {
      acc[filterName] = filter.value.join(",");
    } else {
      acc[filterName] = filter.value;
    }

    return acc;
  }, {});
}

/**
 * Returns the ordering query string depending on gerOrder there are several front-end logic involved.
 * If order is desc, adds "-" char to orderBy.
 * It automatically adds a secondary ordering by id to ensure that the ordering is consistent.
 * Backbone type doesn't support ordering thus ordering is skipped when backbone is selected.
 * @param {Order} order
 * @param {string | null} orderBy
 * @param {string} connectionMethod
 * @returns {number}
 */
export function buildProxyCurlCommand({
  proxyAddress,
  port,
  username,
  password,
  connectionMethod,
  authenticationMethod,
  proxyControl,
}: {
  proxyAddress: string | null;
  port: number;
  username: string;
  password: string;
  connectionMethod: string;
  authenticationMethod: string;
  proxyControl: string;
}) {
  const protocol = proxyControl === "1" ? "socks5" : "http";
  const domainName =
    connectionMethod === "direct"
      ? proxyAddress || WEBSHARE_PROXY_DNS_ADDRESS
      : WEBSHARE_PROXY_DNS_ADDRESS;
  const curlPort =
    authenticationMethod === "username_password" &&
    connectionMethod === "backbone"
      ? "80"
      : String(port);

  return bash({
    protocol,
    proxyUserName: username,
    password,
    domainName,
    authenticationMethod,
    port: curlPort,
  });
}

export function getOrder(
  order: Order,
  orderBy?: string | null,
  connectionMethod?: string
) {
  if (connectionMethod == "backbone") {
    return undefined;
  }
  if (orderBy) {
    if (order == "asc") {
      return `${orderBy},id`;
    } else {
      return `-${orderBy},id`;
    }
  } else {
    return undefined;
  }
}
